// Ported from src/scripts/data/icons.js — clap-hands silhouette (algorithmic boost signal)
export function Cherish({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M7 13c-.7 1.5-.4 3.4 1 4.6 1.7 1.4 4.4 1.3 6.1-.4l3.1-3.1c.9-.9.9-2.3 0-3.2-.4-.4-1-.6-1.6-.6" />
      <path d="M10 8.5l3-3c.9-.9 2.3-.9 3.2 0 .9.9.9 2.3 0 3.2L13 11.8" />
      <path d="M8 11l2.5-2.5c.9-.9 2.3-.9 3.2 0 .9.9.9 2.3 0 3.2L11 14.5" />
      <path d="M3 6l1.5 1M5 3l1 1.5M3 11l1.5-.4" />
    </svg>
  );
}
